import { createAction } from 'actions/utils';
import {
    CLEAR_CRUD_USER,
    CLEAR_CURRENT_USER,
    DELETE_USER_SUCCESS,
    GET_CRUD_USER_REQUEST,
    GET_CRUD_USER_SUCCESS,
    GET_CRUD_USER_ERROR,
    GET_IMPL_SUMMARY_REQUEST,
    GET_IMPL_SUMMARY_SUCCESS,
    GET_IMPL_SUMMARY_ERROR,
    GET_PASSWORD_POLICIES_REQUEST,
    GET_PASSWORD_POLICIES_SUCCESS,
    GET_PASSWORD_POLICIES_ERROR,
    GET_SSO_PROVIER_REQUEST,
    GET_SSO_PROVIER_SUCCESS,
    GET_SSO_PROVIER_ERROR,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_ERROR,
    GET_USERS_HIERACHY_REQUEST,
    GET_USERS_HIERACHY_SUCCESS,
    GET_USERS_HIERACHY_ERROR,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_ERROR,
    GET_USER_PERMISSIONS_REQUEST,
    GET_USER_PERMISSIONS_SUCCESS,
    GET_USER_PERMISSIONS_ERROR,
    GET_USER_SCHEMA_REQUEST,
    GET_USER_SCHEMA_SUCCESS,
    GET_USER_SCHEMA_ERROR,
    USER_TOGGLE_ACTIVATE_SUCCESS,
    GET_USER_COUNTRY_CODES_REQUEST,
    GET_USER_COUNTRY_CODES_SUCCESS,
    GET_USER_COUNTRY_CODES_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getImplSummary() {
    return (dispatch) => {
        dispatch(createAction(GET_IMPL_SUMMARY_REQUEST, {}));
        return Core.usersManager.getImplSummary().then(
            (res) => {
                dispatch(createAction(GET_IMPL_SUMMARY_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_IMPL_SUMMARY_ERROR, error));
                throw error;
            },
        );
    };
}

export function getUsers(data) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(createAction(GET_USERS_REQUEST, {}));
            Core.usersManager.getUsers(data).then(
                (res) => {
                    dispatch(
                        createAction(GET_USERS_SUCCESS, {
                            list: res,
                            page: data.page,
                        }),
                    );
                    resolve(res);
                },
                (error) => {
                    dispatch(createAction(GET_USERS_ERROR, error));
                    reject(error);
                },
            );
        });
}

export function getUsersHierachy() {
    return (dispatch) => {
        dispatch(createAction(GET_USERS_HIERACHY_REQUEST, {}));
        return Core.usersManager.getUsersHierachy().then(
            (res) => {
                dispatch(createAction(GET_USERS_HIERACHY_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USERS_HIERACHY_ERROR, error));
                throw error;
            },
        );
    };
}

export function getUser({ id }) {
    return (dispatch) => {
        dispatch(createAction(GET_USER_REQUEST, {}));
        return Core.usersManager.getUser(id).then(
            (res) => {
                dispatch(createAction(GET_USER_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCrudUser({ id }) {
    return (dispatch) => {
        dispatch(createAction(GET_CRUD_USER_REQUEST, {}));
        return Core.usersManager.getUser(id).then(
            (res) => {
                dispatch(createAction(GET_CRUD_USER_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CRUD_USER_ERROR, error));
                throw error;
            },
        );
    };
}

export function getDuplicateUser({ id }) {
    return (dispatch) => {
        dispatch(createAction(GET_CRUD_USER_REQUEST, {}));
        return Core.usersManager.getDuplicateUser(id).then(
            (user) => {
                dispatch(createAction(GET_CRUD_USER_SUCCESS, user));
            },
            (error) => {
                dispatch(createAction(GET_CRUD_USER_ERROR, error));
                throw error;
            },
        );
    };
}

export function getUserPermissions(id) {
    return (dispatch) => {
        dispatch(createAction(GET_USER_PERMISSIONS_REQUEST, {}));
        return Core.usersManager.getUserPermissions(id).then(
            (res) => {
                dispatch(createAction(GET_USER_PERMISSIONS_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_PERMISSIONS_ERROR, error));
                throw error;
            },
        );
    };
}

export function getPasswordPolicies() {
    return (dispatch) => {
        dispatch(createAction(GET_PASSWORD_POLICIES_REQUEST, {}));
        return Core.usersManager.getPasswordPolicies().then(
            (res) => {
                dispatch(createAction(GET_PASSWORD_POLICIES_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_PASSWORD_POLICIES_ERROR, error));
                throw error;
            },
        );
    };
}

export function getSSOProvider() {
    return (dispatch) => {
        dispatch(createAction(GET_SSO_PROVIER_REQUEST, {}));
        return Core.usersManager.getSSOProvider().then(
            (res) => {
                dispatch(createAction(GET_SSO_PROVIER_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_SSO_PROVIER_ERROR, error));
                throw error;
            },
        );
    };
}

export function clearCurrentUser() {
    return (dispatch) => {
        dispatch(createAction(CLEAR_CURRENT_USER, {}));
    };
}

export function clearCrudUser() {
    return (dispatch) => {
        dispatch(createAction(CLEAR_CRUD_USER, {}));
    };
}

export function getUserSchema() {
    return (dispatch) => {
        dispatch(createAction(GET_USER_SCHEMA_REQUEST, {}));
        return Core.usersManager.getUserSchema().then(
            (res) => {
                dispatch(createAction(GET_USER_SCHEMA_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_SCHEMA_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCountryCodes() {
    return (dispatch) => {
        dispatch(createAction(GET_USER_COUNTRY_CODES_REQUEST, {}));
        return Core.usersManager.getCountryCodes().then(
            (res) => {
                dispatch(createAction(GET_USER_COUNTRY_CODES_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_COUNTRY_CODES_ERROR, error));
                throw error;
            },
        );
    };
}

export function toggleActivateUser(id, isActive) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Core.usersManager.toggleActivateUser(id, isActive).then(
                (data) => {
                    dispatch(
                        createAction(USER_TOGGLE_ACTIVATE_SUCCESS, {
                            id,
                            isActive,
                        }),
                    );
                    resolve(data);
                },
                (error) => {
                    reject(error);
                },
            );
        });
}

export function deleteUser(id) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Core.usersManager.deleteUser(id).then(
                (res) => {
                    if (res && res.id > 0 && res.status === true) {
                        dispatch(createAction(DELETE_USER_SUCCESS, id));
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => {
                    reject(error);
                },
            );
        });
}
